<template>
  <b-row>
    <!-- :to="{ name: 'purchaseorders-add' }" -->
    <b-col cols="12">
      <div class="d-flex justify-content-end my-1">
        <b-button variant="primary" :to="{ name: 'purchaseorder-add' }">
          <span class="text-nowrap">Create Purchase Order</span>
        </b-button>
        <!-- <b-button variant="primary" class="ml-2" :to="{ name: 'lowstock-list' }">
          <span class="text-nowrap">Low Stock Refill</span>
        </b-button> -->
      </div>
    </b-col>
    <b-col cols="12" md="2" sm="2" class="my-1">
      <b-form-group class="mb-0">
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions"  />
      </b-form-group>
    </b-col>

    <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
      <b-button variant="outline-danger"  @click="clearFilters">
        Clear Filters
      </b-button>
    </b-col>

    <b-col cols="12">
      <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="filteredPurchaseOrders"
        :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
        @filtered="onFiltered">

        <!-- Filter input for Order Number -->
        <template #head(orderNumber)>
          <div class="d-flex flex-column">
            <span>Order Number</span>
            <b-form-input v-model="filters.orderNumber" placeholder="Filter by Order Number" size="sm"
              @input="filterTable" />
          </div>
        </template>

        <!-- Filter input for Supplier Name -->
        <template #head(supplierName)>
          <div class="d-flex flex-column">
            <span>Supplier Name</span>
            <b-form-input v-model="filters.supplierName" placeholder="Filter by Supplier Name" size="sm"
              @input="filterTable" />
          </div>
        </template>

        <!-- Filter input for Warehouse Name -->
        <template #head(warehouseName)>
          <div class="d-flex flex-column">
            <span>Warehouse Name</span>
            <b-form-input v-model="filters.warehouseName" placeholder="Filter by Warehouse Name" size="sm"
              @input="filterTable" />
          </div>
        </template>

        <template #head(status)>
          <div class="d-flex flex-column">
            <span>Status</span>
            <b-form-select v-model="filters.status" :options="statusOptions" size="sm" @change="filterTable"
              placeholder="Filter by Status" />
          </div>
        </template>
        <template #head(issueDate)>
          <div class="d-flex flex-column">
            <span>Issue Date</span>
            <DatePicker v-model="filters.issueDate" range placeholder="Select Date Range" size="sm"
              @change="filterTable" :clearable="false" :input-attr="{ readonly: true }" @focus="openCalendar"
              class="small-datepicker" />
          </div>
        </template>

        <!-- Filter input for Created On -->
        <template #head(createdOn)>
          <div class="d-flex flex-column">
            <span>Created On</span>
            <DatePicker v-model="filters.createdOn" range placeholder="Select Date Range" size="sm"
              @change="filterTable" :clearable="false" :input-attr="{ readonly: true }" @focus="openCalendar"
              class="small-datepicker" />
          </div>
        </template>

        <template #cell(supplierName)="data">
          {{ getSupplierNameById(data.item.supplierId) }}
        </template>
        <template #cell(warehouseName)="data">
          {{ getWarehouseNameById(data.item.warehouseId) }}
        </template>
        <template #cell(createdOn)="data">
          {{ formatDate(data.item.createdOn) }}
        </template>
        <template #cell(issueDate)="data">
          {{ formatDate(data.item.issueDate) }}
        </template>
        <template #cell(total)="data">
          <span v-if="!data.item.hidePrice">
            Rs {{ data.item.total ? data.item.total.toFixed(2) : "0.00" }}
          </span>
          <span v-else> - </span>
        </template>

        <template #cell(isActive)="data">
          <b-badge v-if="data.item.isActive" variant="primary">
            Active
          </b-badge>
          <b-badge v-else variant="danger"> Inactive </b-badge>
        </template>
        <template #cell(orderType)="data">
          <!-- <b-badge v-if="data.item.orderType === 0" variant="primary">
            Fixed Order
          </b-badge> -->
          <b-badge v-if="data.item.orderType === 1" variant="primary">
            Variable Order
          </b-badge>
          <b-badge v-else-if="data.item.orderType === 2" variant="primary">
            OneOff Order
          </b-badge>
        </template>
        <template #cell(status)="data">
          <b-badge v-if="data.item.hasConvertedToPurchaseInvoice" variant="success">
            Completed
          </b-badge>
          <b-badge v-else-if="data.item.status === 0" variant="info">
            New
          </b-badge>

          <b-badge v-else-if="data.item.status === 2" variant="danger">
            Cancelled
          </b-badge>
          <!-- <b-badge v-else variant="danger"> Blocked </b-badge> -->
        </template>
        <template #cell(actions)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template v-slot:button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item :to="getPurchaseOrderId(data.item.id)">
              <feather-icon icon="EyeIcon" class="mr-50" />
              <span>View</span>
            </b-dropdown-item>
            <b-dropdown-item :to="EditPurchaseOrderId(data.item.id)">
              <feather-icon icon="Edit2Icon" class="mr-50" />
              <span>Edit</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="
              !data.item.hasConvertedToPurchaseInvoice &&
              data.item.status === 0
            " @click="convertPO(data.item)">
              <feather-icon icon="Edit2Icon" class="mr-50" />

              <span>Convert</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="
              !data.item.hasConvertedToPurchaseInvoice &&
              data.item.status === 0
            " @click="CancelPO(data.item)">
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Cancel</span>
            </b-dropdown-item>
            <b-dropdown-item @click="viewPurchaseOrderDocuments(data.item.id)">
              <feather-icon icon="PaperclipIcon" />
              <span class="align-middle ml-50">Documents</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <b-col md="3" class="d-flex justify-content-end">
        <b-modal ref="modal-view-purchase-order-document" id="modal-view-purchase-order-document" ok-only
          ok-title="View" centered size="lg" title="View Purchase Order Documents" :hide-footer="true">
          <DocumentUpload @deleteFile="deleteFile" @downloadFile="downloadFile" @uploadFiles="uploadFiles"
            :documentDetails="documentDetails" />
        </b-modal>
      </b-col>

      <div class="d-flex justify-content-center mb-1">
        <b-spinner variant="success" label="Spinning" block v-if="loading"
          style="width: 3rem; height: 3rem"></b-spinner>
      </div>
    </b-col>

    <b-col cols="12">
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
        class="my-0" />
      <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapActions, mapGetters } from "vuex";
import dayjs from "dayjs";

import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BSpinner,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";

import DocumentUpload from "@/views/component/DocumentUpload.vue";
import { deletePurchaseOrderDocument, uploadPurchaseOrderMultipleDocuments, uploadPurchaseOrderDocument, downloadPurchaseOrderDocument } from '@/store/purchaseorder/services';
import { customSwal, customError } from '@/libs/customFn';

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BDropdownItem,
    DocumentUpload,
    DatePicker
  },
  data() {
    return {
      supplierName: "",
      purchaseOrderData: [],
      perPage: 5,
      dayjs,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 0,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      filters: {
        orderNumber: "",
        supplierName: "",
        warehouseName: "",
        status: null,
        issueDate: null,
        createdOn: null
      },
      statusOptions: [
        { value: null, text: "All" },
        { value: "new", text: "New" },
        { value: "completed", text: "Completed" },
        // { value: 1, text: "Blocked" },
        { value: 2, text: "Cancelled" },
      ],
      fields: [
        { key: "orderNumber", label: "ORDER NUMBER", sortable: true },
        { key: "supplierName", label: "SUPPLIER NAME", sortable: true },
        { key: "warehouseName", label: "WAREHOUSE NAME", sortable: true },
        { key: "issueDate", label: "ISSUE DATE", sortable: true },
        { key: "createdOn", label: "CREATED ON", sortable: true },
        { key: "status", label: "STATUS", sortable: true },
        { key: "total", label: "TOTAL", sortable: true },
        "actions",
      ],
      hasConvertedToPurchaseInvoice: false,
      documentDetails: {
        isDelete: false,
        documentList: []
      },
      PoId: "",
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    ...mapGetters("purchaseOrderModule", {
      purchaseOrderList: "purchaseorders",
      purchaseorderId: "purchaseorderId",
      loading: "loading",
      documents: "documents",
      file: "file",
    }),
    ...mapGetters("supplierModule", {
      supplierList: "suppliers",
      supplierLoading: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouses: "warehouse",
      warehouseLoading: "loading",
    }),

    filteredPurchaseOrders() {
      let purchaseOrderFilter = this.purchaseOrderList.filter((order) => {
        const matchesOrderNumber = this.filters.orderNumber
          ? order.orderNumber && order.orderNumber.toString().toLowerCase().includes(this.filters.orderNumber.toLowerCase())
          : true;

        // Filter by Supplier Name
        const supplierName = this.getSupplierNameById(order.supplierId) || "";
        const matchesSupplierName = this.filters.supplierName
          ? supplierName.toLowerCase().includes(this.filters.supplierName.toLowerCase())
          : true;

        // Filter by Warehouse Name
        const warehouseName = this.getWarehouseNameById(order.warehouseId) || "";
        const matchesWarehouseName = this.filters.warehouseName
          ? warehouseName.toLowerCase().includes(this.filters.warehouseName.toLowerCase())
          : true;

        // Filter by Status
        const matchesStatus = this.filters.status !== null
          ? (this.filters.status === "new" && order.status === 0 && !order.hasConvertedToPurchaseInvoice) ||
          (this.filters.status === "completed" && order.status === 0 && order.hasConvertedToPurchaseInvoice) ||
          order.status === parseInt(this.filters.status, 10)
          : true;


        // Filter by Issue Date
        const matchesIssueDate =
          this.filters.issueDate && this.filters.issueDate.length === 2
            ? dayjs(order.issueDate).isAfter(this.filters.issueDate[0]) &&
            dayjs(order.issueDate).isBefore(this.filters.issueDate[1])
            : true;

        // Filter by Created On
        const matchesCreatedOn =
          this.filters.createdOn && this.filters.createdOn.length === 2
            ? dayjs(order.createdOn).isAfter(this.filters.createdOn[0]) &&
            dayjs(order.createdOn).isBefore(this.filters.createdOn[1])
            : true;

        return (
          matchesOrderNumber &&
          matchesSupplierName &&
          matchesWarehouseName &&
          matchesStatus &&
          matchesIssueDate &&
          matchesCreatedOn
        );
      });
      
      this.totalRows = purchaseOrderFilter.length;

      return purchaseOrderFilter;
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    getpurchaseOrderData(data) {
      console.log(data);
      this.purchaseOrderData = data;
    },

    async viewPurchaseOrderDocuments(referenceId) {
      try {
        this.PoId = referenceId
        console.log('referenceId', referenceId);
        console.log('PoId', this.PoId);
        await this.getPurchaseOrderDocumentListAction(referenceId);
        if (this.documents.length > 0) {
          this.documentDetails.documentList = this.documents;
          this.documentDetails.isDelete = true;
        }
        this.$refs["modal-view-purchase-order-document"].show();
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    },

    async downloadFile(downloadById, fileName) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document is being prepared for download',
        onOpen: () => {
          loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await downloadPurchaseOrderDocument(downloadById);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: response.headers['content-type'] || 'application/octet-stream',
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error('Download failed:', error);
        loader.close();
        this.error('Failed to download the file. Please try again.'); // Updated error message for better clarity
      }
    },

    async uploadFiles(selectedFiles) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document(s) is being added',
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
      const referenceId = this.PoId;

      const maxSize = 20 * 1024 * 1024;
        if (this.selectedFiles && this.selectedFiles.size > maxSize) {
          alert('File size exceeds 20 MB limit. Please choose a smaller file.');
          this.submitting = false;
          return;
        }

      if (selectedFiles.length > 1) {

        await uploadPurchaseOrderMultipleDocuments(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal('Your file(s) have been successfully uploaded.');
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      } else if (selectedFiles.length < 2) {
        await uploadPurchaseOrderDocument(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal('Your file(s) have been successfully uploaded.');
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      }

      await this.getPurchaseOrderDocumentListAction(referenceId);
      this.documentDetails.documentList = this.documents;
      this.documentDetails.isDelete = true;

      this.$nextTick(() => {
        this.$bvModal.show('modal-view-purchase-order-document');
      });
    },
    async deleteFile(deleteById) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document is being deleted',
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await deletePurchaseOrderDocument(deleteById)
        .then((response) => {
          loader.close();
          customSwal("File deleted successfully!");
        })
        .catch((error) => {
          loader.close();
          customError(error);
        });

      await this.getPurchaseOrderDocumentListAction(this.PoId);
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show('modal-view-purchase-order-document');
      });
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);

      var formatted_date = `${year}-${month}-${day}`;
      return formatted_date == "1-01-01" ? "-" : formatted_date;
    },
    getPurchaseOrderId(item) {
      return "/purchaseorder/view/" + item;
    },
    EditPurchaseOrderId(item) {
      return "/purchaseorder/edit/" + item;
    },
    removePurchaseOrder(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removePurchaseOrdersAction(id);
          this.$swal({
            icon: "success",
            title: "Deleted!",
            text: "Your file has been deleted.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Your file is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },

    CancelPO(item) {
      let payload = {
        id: item.id,
        status: 2,
        supplierId: item.supplierId,
        quantity: item.quantity,
        totalCost: item.totalCost,
        issueDate: item.issueDate,
        balance: item.balance,
        salesPersonId: item.salesPersonId,
        paymentMethod: item.paymentMethod,
        dueDate: item.dueDate,
        orderNumber: item.orderNumber,
        subTotal: item.subTotal,
        discount: item.discount,
        tax: item.tax,
        total: item.total,
        note: item.note,
        warehouseId: item.warehouseId,
        purchaseOrderItems: item.purchaseOrderItems,
      };
      this.updatePurchaseOrdersAction(payload)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success!",
            text: "Purchase Order Cancelled",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.getPurchaseOrdersListAction();
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: "Error!",
            text: "Purchase Order Not Cancelled",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        });
    },
    convertPO(item) {
      // Open edit Purchase Invoice
      try {
        this.$router.push({
          name: "purchaseinvoice-edit",
          query: { PoID: item.id },
        });
      } catch (error) {
        this.$swal({
          title: "Error!",
          text: "There was an error navigating to the Purchase Invoice creation page.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },
    getPurchaseOrderIdComplete(item) {
      let payload = {
        id: item.id,
        status: 1,
        supplierId: item.supplierId,
        quantity: item.quantity,
        totalCost: item.totalCost,
        issueDate: item.issueDate,
        balance: item.balance,
        salesPersonId: item.salesPersonId,
        paymentMethod: item.paymentMethod,
        dueDate: item.dueDate,
        orderNumber: item.orderNumber,
        subTotal: item.subTotal,
        discount: item.discount,
        tax: item.tax,
        total: item.total,
        note: item.note,
        warehouseId: item.warehouseId,
        purchaseOrderItems: item.purchaseOrderItems,
      };
      this.updatePurchaseOrdersAction(payload)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success!",
            text: "Purchase Order Completed",
            customClass: {
              confirmButton: "btn btn-success",
            },
          }).then(() => {
            window.location.reload();
          });
          this.getPurchaseOrdersListAction();
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: "Error!",
            text: "Purchase Order Not Completed",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        });
    },
    getSupplierNameById(id) {
      let supplier = this.supplierList.filter((obj) => {
        return obj.id === id;
      });
      if (supplier.length > 0) {
        return supplier[0].name;
      }
    },
    getWarehouseNameById(id) {
      let warehouse = this.warehouses.filter((obj) => {
        return obj.id === id;
      });
      if (warehouse.length > 0) {
        return warehouse[0].name;
      }
    },
    ...mapActions("purchaseOrderModule", [
      "getPurchaseOrdersListAction",
      "removePurchaseOrdersAction",
      "updatePurchaseOrdersAction",
      "getPurchaseOrderDocumentListAction"
    ]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),
    ...mapActions("supplierModule", ["getSupplierListAction"]),
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    filterTable() {
      // This method is called whenever the user types in a filter input.
      this.currentPage = 1;
    },
    openCalendar(event) {
      event.target.blur();
      event.target.click();

      document.addEventListener('click', this.closeCalendar);
    },
    closeCalendar(event) {
      const datePicker = this.$refs.datePicker.$el;
      if (!datePicker.contains(event.target)) {
        this.$refs.datePicker.hideCalendar();

        document.removeEventListener('click', this.closeCalendar);
      }
    },
    clearFilters() {
      // Resetting all filters
      this.filters = {
        orderNumber: "",
        supplierName: "",
        warehouseName: "",
        status: null,
        issueDate: null,
        createdOn: null
      };
      // Optionally reset the table pagination if needed
      this.currentPage = 1;
    },
  },
  async mounted() {
    await this.getPurchaseOrdersListAction()
      .then(() => {
        this.totalRows = this.purchaseOrderList.length;
      })
      .catch((response) => {
        console.log(response);
      });
    await this.getSupplierListAction();
    await this.getWarehouseListAction();
  },
};
</script>

<style scoped>
.small-datepicker {
  width: 150px;
}
</style>
